import React from "react";

const shubhra_shevkar = () => {
  return (
    <div>
      <h1>Shubhra Shevkar</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        There was an initial criteria of 8 CGPA, after which we appeared for an
        aptitude test.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        There were two interview rounds: Technical and HR. I gave my technical
        round first, and around 15-20 minutes later, I was called in for the HR
        round. After that, it was just a matter of waiting for the final
        results.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        It was a two hour test consisting of{" "}
      </p>

      <ol>
        <li>MCQs - based on OOPS, DBMS, etc. </li>
        <li>3 SQL queries </li>
        <li>
          3 Coding questions - one involved debugging a code snippet, and
          another was similar to the “burst balloons in a circle” type problem.
        </li>
      </ol>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        19 students were shortlisted for the interviews.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The test was conducted on 6th August, and the interviews were scheduled
        for 8th August. The shortlist was announced right after the
        Pre-Placement Talk, just before the interviews began.
        <br />
        During that period, I revised my projects, and focused on strengthening
        OOPS and DBMS concepts instead of learning anything new.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        There were two interview rounds.
        <br />
        Technical round: The interview began with a detailed discussion of my
        projects and the technical internship I completed over the summer. I was
        asked to write a few SQL queries, design a schema, and then run queries
        on it. This was followed by questions on OOPS, where I was asked to
        design the class model and explain it. There were also a few questions
        related to REST API.
        <br />
        Around 10 students gave the HR round.
      </p>

      <p>
        HR Round: This round began with a self-introduction, where I highlighted
        my extracurricular interests. I was asked standard questions such as my
        greatest strengths, biggest weakness, and one trait I’d like to improve.
        The interviewer also asked about my role as Accounts Head at Debsoc, the
        debating competitions I’ve participated in, and what debating has taught
        me. I wasn’t asked technical questions, though some others were.
      </p>

      <p>
        After the HR interviews 6 students were shortlisted for the internship.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        Technical Round: The main focus was on DBMS and OOPS. Very few questions
        were asked on DSA.
        <br />
        HR Round: A lot of behavioural questions were asked.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        Sheets: Striver’s A2Z DSA Sheet
        <br />
        YouTube Channels: Code with Harry, Gate Smashers, freeCodeCamp
        <br />
        Practice Sites: LeetCode and SQL-Practice for DSA and SQL questions
        <br />
        Textbooks:
      </p>

      <ul>
        <li>
          <em>Database System Concepts</em> – Silberschatz, Korth, Sudarshan{" "}
        </li>
        <li>
          <em>Computer Networking: A Top-Down Approach</em> – Kurose &amp; Ross{" "}
        </li>
        <li>
          <em>Data Structures &amp; Algorithm Analysis in C</em> – Mark Allen
          Weiss
        </li>
      </ul>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Stay calm and take your time to thoroughly read and understand the
        problem before starting. Even if your solution passes only a few test
        cases, it still shows your approach and logic and a lot of the time it’s
        enough to get you a spot in the interviews.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        My technical round started with an in depth discussion about a few of my
        projects.
        <br />A lot of the questions in my HR interview were either based on or
        inspired by my clubs/extracurricular activities.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Focus strongly on DBMS, you should be comfortable writing and explaining
        all types of queries. Also, make sure to research the company’s
        business, values, and work culture before the interviews.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Don’t get disheartened by rejections, the right opportunity will come
        your way. Keep putting in consistent effort and trust that your hard
        work will pay off. You’ve got this!
      </p>

      <p>
        <strong>Contact Info </strong>
      </p>

      <p>
        <strong>Email :</strong> <a href="mailto:shubhrashevkar@gmail.com">shubhrashevkar@gmail.com</a>
      </p>

      <hr />
    </div>
  );
};

export default shubhra_shevkar;
